// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"844":"0058a24948441be3","895":"bde01f7d76df312a","6321":"5dab3e4f8afdf26c"}[chunkId] + ".css";
};